export default "__VITE_ASSET__BG5tknT9__"